import { Link } from "react-router-dom";
import { Panel, StatusDot } from "@/components/mh/bits";

export const RolloutMatrix = ({ matrix, agents, autonomyLevels, hex }) => {
  const bySlug = Object.fromEntries(agents.map((a) => [a.slug, a]));
  return (
    <Panel cls="p-4 sm:p-5 overflow-x-auto" testId="rollout-matrix">
      <div className="min-w-[760px]">
        <div className="grid grid-cols-[150px_repeat(3,1fr)] gap-2">
          <div />
          {autonomyLevels.map((a) => <div key={a} className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground px-2">{a}</div>)}
          {matrix.map((row, i) => (
            <div key={row.stage} className="contents">
              <div className="py-3 pr-2">
                <div className="font-mono text-[10px] text-muted-foreground">0{i + 1}</div>
                <div className="font-display text-xl">{row.stage}</div>
              </div>
              {row.cells.map((c) => (
                <div key={c.autonomy} className="rounded-lg border border-white/[0.06] bg-white/[0.015] p-2 space-y-1 min-h-[72px]" data-testid={`matrix-cell-${row.stage}-${c.autonomy}`.toLowerCase().replace(/\s/g, "-")}>
                  {c.agents.map((s) => (
                    <Link key={s} to={`/atlas/${s}`} className="flex items-center gap-2 px-2 py-1.5 rounded-md text-xs hover:bg-white/[0.06] transition-colors" style={{ borderLeft: `2px solid ${hex}` }}>
                      <StatusDot status={bySlug[s]?.runtime?.status} />
                      <span className="truncate">{bySlug[s]?.name}</span>
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Panel>
  );
};
